import { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { Tab } from '@safedns/skydns-ui-react-lib';

import AuthContext from '../../contexts/authContext';
import styles from './SubMenu.module.scss';

const SubMenu = () => {
  const location = useLocation();
  const { availableFeatures } = useContext(AuthContext);

  const {
    areAgentsAvailable,
    areCollectionsAvailable,
    areLocalDomainsAvailable,
    maxDesktopAgent,
  } = availableFeatures;

  const currentSection = location.pathname.split('/')[1];

  const tabs = [
    {
      id: 'releases',
      label: 'Релизы',
      link: 'releases',
      visible: areCollectionsAvailable || maxDesktopAgent,
    },
    {
      id: 'deploy',
      label: 'Распространение',
      link: 'deploy',
      visible: areAgentsAvailable && areLocalDomainsAvailable,
    },
    {
      id: 'users',
      label: 'Пользователи',
      link: 'users',
      visible: areAgentsAvailable,
    },
    {
      id: 'collections',
      label: 'Коллекции',
      link: 'collections',
      visible: areAgentsAvailable && areCollectionsAvailable,
    },
  ];

  return (
    <div className={styles.container}>
      {tabs
        .filter((tab) => tab.visible)
        .map(({ id, label, link }) => (
          <div key={id} className={styles.item}>
            <Tab
              link={link}
              isChecked={currentSection === link}
            >
              {label}
            </Tab>
          </div>
        ))}
    </div>
  );
};

export default SubMenu;
